import React from 'react'
import PropTypes from 'prop-types'
import AdditionalDetailsForm from './AdditionalDetailsForm'
import withOnboardingSection from 'components/Onboarding/withOnboardingSection'
import {
  additionalDetails,
} from 'utils/financialAccountDetailsConfig'
import { SCHWAB_IRA, SCHWAB_ONE_PERSONAL } from 'utils/financialAccountTypes.js'
import {
  getJointOwner,
  getFinancialAccount,
  getPreviousSectionInfo,
  continueToNextSection
} from 'utils/financialAccounts'
import { updateFinancialAccount } from 'utils/apiRequest'

const Section = withOnboardingSection(AdditionalDetailsForm)

const prepareFormDataForRender = (financialAccount, fields) => {
  if (!financialAccount) return

  const {
    attributes: {
      sepAllowSeparateDeferral,
      sepCatchUpContributionsPermitted,
      simpleCatchUpContributionsPermitted
    }
  } = financialAccount

  const additionalDetails = {}

  Object.keys(fields).map(key => additionalDetails[key] = financialAccount.attributes[key])
  additionalDetails.sepAllowSeparateDeferral = sepAllowSeparateDeferral ? 'Yes' : 'No'
  additionalDetails.sepCatchUpContributionsPermitted = sepCatchUpContributionsPermitted ? 'Yes' : 'No'
  additionalDetails.simpleCatchUpContributionsPermitted = simpleCatchUpContributionsPermitted ? 'Yes' : 'No'

  return additionalDetails
}

const AdditionalDetails = (props) => {
  const {
    financialAccounts,
    jointOwners,
    isMobile,
    hide,
    isLoading,
    editFinancialAccount,
    location: {
      payload: {
        financialAccountId,
        financialAccountType
      }
    },
  } = props

  const {
    upperTitle,
    fields,
    fieldsToSubmit
  } = additionalDetails

  const currentSection = 'additionalDetails'

  const jointOwner = getJointOwner(jointOwners, financialAccountId)

  const financialAccount = getFinancialAccount(financialAccounts, financialAccountId)

  const data = prepareFormDataForRender(financialAccount, fields)

  let accountSubType
  if (financialAccount) {
    const {
      attributes: {
        subType
      }
    } = financialAccount
    accountSubType = subType
  }

  const handleContinueToNextSection =  () => {
    continueToNextSection({
      currentFinancialAccountId: financialAccountId,
      currentFinancialAccountType: financialAccountType,
      currentSection,
      financialAccounts,
      jointOwner,
      isUTMA: accountSubType === SCHWAB_ONE_PERSONAL.ACCOUNT_TYPES.UTMA,
      isIRA: financialAccountType === SCHWAB_IRA.ACCOUNT_TYPE_ROUTE,
    })
  }

  const prevPageInfo = getPreviousSectionInfo({
    financialAccounts,
    financialAccountId,
    financialAccountType,
    jointOwner,
    isMobile,
    currentSection
  })

  const submitAction = (formData) => {
    const submitData = {
      ...formData,
      reviewedAdditionalDetails: true,
    }
    return updateFinancialAccount(financialAccountId, submitData)
  }

  return (
    <Section
      {...props}
      subType={accountSubType}
      formName={upperTitle}
      data={data}
      prevPageInfo={prevPageInfo}
      goNextSection={handleContinueToNextSection}
      isMobile={isMobile}
      isLoading={isLoading}
      hide={hide || isLoading}
      setData={editFinancialAccount}
      submitAction={submitAction}
      mapValues={fieldsToSubmit} />
  )
}

AdditionalDetails.propTypes = {
  hide: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  financialAccounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  jointOwners: PropTypes.arrayOf(PropTypes.object).isRequired,
  editFinancialAccount: PropTypes.func.isRequired,
}

export default AdditionalDetails



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/AdditionalDetails.js